
export const actionTypes = {
  AUDIT_FILTERS_RESET: 'AUDIT_FILTERS_RESET',
  AUDIT_FILTERS_SET: 'AUDIT_FILTERS_SET',
  AUDIT_FILTERS_UPDATE: 'AUDIT_FILTERS_UPDATE',
};

export const actionCreators = {
  reset: () => ({
    type: actionTypes.AUDIT_FILTERS_RESET,
  }),
  set: (auditFilters: any) => ({
    type: actionTypes.AUDIT_FILTERS_SET,
    payload: { auditFilters },
  }),
  update: (auditFilters: any) => ({
    type: actionTypes.AUDIT_FILTERS_UPDATE,
    payload: { auditFilters },
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
